import { Button } from "@/components/ui/button";
import { Download, RefreshCw } from "lucide-react";

interface Props {
  version: string;
  apkUrl: string | null;
  onDismiss: () => void;
}

export const UpdateAvailableModal = ({ version, apkUrl, onDismiss }: Props) => {
  const handleDownload = () => {
    if (apkUrl) {
      window.open(apkUrl, "_system");
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="mx-4 w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
            <RefreshCw className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-900">Mise à jour disponible</h2>
            <p className="text-sm text-muted-foreground">Version {version}</p>
          </div>
        </div>

        <p className="mb-6 text-sm text-gray-600">
          Une nouvelle version de l'application est disponible. Mettez à jour pour bénéficier des dernières améliorations.
        </p>

        <div className="flex flex-col gap-2">
          {apkUrl ? (
            <Button onClick={handleDownload} className="w-full gap-2">
              <Download className="h-4 w-4" />
              Télécharger la mise à jour
            </Button>
          ) : (
            <p className="text-center text-sm text-muted-foreground">
              Contactez votre administrateur pour obtenir la mise à jour.
            </p>
          )}
          <Button variant="ghost" onClick={onDismiss} className="w-full text-muted-foreground">
            Plus tard
          </Button>
        </div>
      </div>
    </div>
  );
};
